import { ThunkAction } from 'redux-thunk';

import * as CatalogClient from 'Clients/Catalog';
import * as ImagesClient from 'Clients/Images';
import { Data as StudioData } from 'Clients/Studio';

import RootState from 'Store/Root';
import { SectionMap } from 'Types/Rooms';

export const LOADING_ROOMS = 'LOADING_ROOMS';
export const LOADED_ROOMS = 'LOADED_ROOMS';
export const LOAD_ROOMS_FAILED = 'LOAD_ROOMS_FAILED';

export const LOADING_ROOM_INFO = 'LOADING_ROOM_INFO';
export const LOADED_ROOM_INFO = 'LOADED_ROOM_INFO';
export const LOAD_ROOM_INFO_FAILED = 'LOAD_ROOM_INFO_FAILED';

export interface RoomsAction {
  type: string;
  items?: TrykApi.Catalog.IBrandRoomScenes[];
  sectionMap?: SectionMap;
  categories?: TrykApi.Catalog.IRoomSceneCategory[];
  roomId?: number;
  roomInfo?: TrykApi.Images.IRoomInfo;
}

function loadingRooms(): RoomsAction {
  return {
    type: LOADING_ROOMS
  };
}

function roomsLoadFailed(): RoomsAction {
  return {
    type: LOAD_ROOMS_FAILED
  };
}

function roomsLoaded(items: TrykApi.Catalog.IBrandRoomScenes[], map: SectionMap, categories: TrykApi.Catalog.IRoomSceneCategory[]): RoomsAction {
  return {
    type: LOADED_ROOMS,
    items: items,
    sectionMap: map,
    categories: categories
  };
}

function loadingRoomInfo(roomId: number): RoomsAction {
  return {
    type: LOADING_ROOM_INFO,
    roomId: roomId
  };
}

function roomInfoLoadFailed(roomId: number): RoomsAction {
  return {
    type: LOAD_ROOM_INFO_FAILED,
    roomId: roomId
  };
}

function roomInfoLoaded(roomId: number, info: TrykApi.Images.IRoomInfo): RoomsAction {
  return {
    type: LOADED_ROOM_INFO,
    roomId: roomId,
    roomInfo: info
  };
}

export function loadRooms(): ThunkAction<Promise<any>, RootState, any> {
  return (dispatch, getState) => {
    const state = getState();

    if (state.rooms.loaded) {
      return Promise.resolve(true);
    }

    dispatch(loadingRooms());

    return Promise.all([
      CatalogClient.Global.getRooms(),
      StudioData.getSectionRoomScenesMap(),
      CatalogClient.Global.getRoomSceneCategories()
    ]).then(
      x => dispatch(roomsLoaded(x[0], x[1], x[2])),
      e => dispatch(roomsLoadFailed())
    );
  };
}

export function loadRoomInfo(roomId: number): ThunkAction<Promise<any>, RootState, any> {
  return (dispatch, getState) => {
    const state = getState();

    const { roomInfoById, roomInfoLoadingById } = state.rooms;

    if (roomInfoById[roomId]) {
      return Promise.resolve(true);
    } else if (roomInfoLoadingById[roomId]) {
      return Promise.reject(
        new Error(`Room info ${roomId} is already loading.`)
      );
    }

    dispatch(loadingRoomInfo(roomId));

    return ImagesClient.Urls.Room.getRoomInfo(roomId).then(
      x => dispatch(roomInfoLoaded(roomId, x)),
      e => dispatch(roomInfoLoadFailed(roomId))
    );
  };
}
